import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';


const channels = [
  {
    link: "https://www.mooimom.id/product-category/brand/?brand=59S&utm_source=instagram&utm_medium=profile&utm_campaign=59s_mooimom",
    image: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/mooimom2.jpg",
    alt: "MOOIMOM logo"
  },
  {
    link: "https://api.whatsapp.com/send?phone=6281288446533&utm_source=instagram&utm_medium=profile&utm_campaign=59s_whatsapp",
    image: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/wa.jpg",
    alt: "whatsapp"
  },
  {
    link: "https://shopee.co.id/shop/12708550/search?shopCollection=28747691/?utm_source=instagram.59s&utm_medium=seller&utm_campaign=s12708550_SS_ID_IG04_59S_Category_Page&utm_content=instagram",
    image: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/shopee.jpg",
    alt: "shopee"
  },
  {
    link: "https://www.tokopedia.com/mooimom/etalase/59s-uvc-sterilizer-official-distributor-for-indonesia/",
    image: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/tokopedia.jpg",
    alt: "tokopedia"
  },
  {
    link: "https://www.blibli.com/merchant/mooimom/MOM-26112?page=1&start=0&pickupPointCode=&cnc=&multiCategory=true&excludeProductList=true&promoTab=true&sort=7",
    image: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/blibli.jpg",
    alt: "blibli"
  },
  {
    link: "https://www.lazada.co.id/tnp-international/",
    image: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/lazada.jpg",
    alt: "lazada"
  },
  {
    link: "https://www.jd.id/shop/MOOIMOM_10004121.html",
    image: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/jd.id.jpg",
    alt: "jdid"
  },
]

const products = [
  {
    link: "https://www.mooimom.id/product/t5-uvc-led-sterilizing-box-built-with-battery-boks-sterilizer-portable/?utm_source=instagram&utm_medium=profile&utm_campaign=59s_product",
    image: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/59s/T5.jpg",
    name: "59S UVC LED Sterilizing Box"
  },
  {
    link: "https://www.mooimom.id/product-category/brand/?brand=59S&utm_source=instagram&utm_medium=profile&utm_campaign=59s_product",
    image: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/59s/p18.jpg",
    name: "59S UVC LED Toys Sterilizer"
  },
  {
    link: "https://www.mooimom.id/product/p14-cled-strilizing-mommy-bag-tas-strerilizer-portable/?utm_source=instagram&utm_medium=profile&utm_campaign=59s_product",
    image: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/59s/p14.jpg",
    name: "59S UVC Led Sterilizing Mommy Bag"
  },
]

const others = [
  {
    link: "https://www.mooimom.id/product-category/brand/?brand=59S&utm_source=instagram&utm_medium=profile&utm_campaign=59s_catalog",
    name: "Katalog"
  },
  {
    link: "https://api.whatsapp.com/send?phone=6281288446533&utm_source=landingpage&utm_medium=instagram.59s&utm_campaign=IG",
    name: "Customer Service"
  },
  {
    link: "https://www.mooimom.id/store-locations?utm_source=instagram&utm_medium=profile&utm_campaign=59s_store_location",
    name: "Store Location"
  },
]

const SWelcome = () => {
  const router = useRouter();
  const year = new Date().getFullYear();

  return (
    <div className="font-poppins">
      <div className="flex items-center justify-center h-20 bg-welcome59sBg md:hidden">
        <Link href="https://www.mooimom.id/product-category/brand/?brand=59S&utm_source=instagram&utm_medium=profile&utm_campaign=59s_logo">
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/59s/59s-logo-white.png"}
            alt="59s logo image"
            quality={100}
            width={100}
            height={65}
            className="w-20"
          />
        </Link>
      </div>
      <div className="container items-center hidden py-5 md:flex">
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/59s/59s-logo-(150x100).jpg"}
          alt="59s logo image"
          quality={100}
          width={100}
          height={65}
          className="w-20"
        />
      </div>
      <div className="bg-welcomeGrey">
        <div className="md:hidden">
          <div className="px-[50px] py-4">
            <Link href="https://www.mooimom.id/product-category/brand/?brand=59S&utm_source=instagram&utm_medium=profile&utm_campaign=59s_logo">
              <Image
                src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/59s/hello-moms-mobile.png"}
                alt="main banner"
                quality={100}
                width={408}
                height={152}
              />
            </Link>
          </div>
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/59s/top-mobile.png"}
            alt="main banner"
            quality={100}
            width={576}
            height={693}
          />
        </div>
        <div className="hidden md:block">
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/59s/top-desktop.jpg"}
            alt="main banner"
            quality={100}
            width={1400}
            height={465}
            className="w-full"
          />
        </div>
        <div className="container py-10">
          <h2 className="text-2xl font-medium text-center text-black md:text-3xl">Shop Us Online</h2>
          <div className="grid grid-cols-4 gap-2 my-5 md:gap-4 md:grid-cols-8 md:px-4">
            {channels.map((channel, index) => (
              <button
                className={`col-span-2 ${index === 0 ? "col-start-2 md:col-start-1" : ""} ${index === 4 ? "md:col-start-2" : ""} min-h-[60px] w-full bg-white p-1 md:p-2 rounded-lg shadow-md`}
                onClick={() => router.push(channel.link)}
              >
                <Image
                  src={channel.image}
                  alt={channel.alt}
                  quality={100}
                  width={250}
                  height={80}
                />
              </button>
            ))}
          </div>
          <h2 className="mt-10 text-2xl font-medium text-center text-black md:text-3xl">Our Best-Seller Products</h2>
          <div className="grid grid-cols-1 gap-4 mt-5 gap-y-8 md:grid-cols-3">
            {products.map((product, index) => (
              <div key={index}>
                <Link href={product.link}>
                  <Image
                    src={product.image}
                    alt={product.name}
                    quality={100}
                    width={400}
                    height={400}
                  />
                  <p className="mt-2 text-base text-center text-black">{product.name}</p>
                </Link>
              </div>
            ))}
          </div>
          <h2 className="mt-10 text-2xl font-medium text-center text-black md:text-3xl">Keep Engaged With Us</h2>
          <div className="flex justify-center mt-5">
            <div>
            {others.map((other, index) => (
              <button
                key={index}
                className="w-full p-4 mt-4 rounded-lg shadow-md bg-welcome59sBg"
                onClick={() => router.push(other.link)}
              >
                <p className="text-base font-medium text-center text-white">{other.name}</p>
              </button>
            ))}
            </div>
          </div>
        </div>
      </div>
      <div className="container py-6 text-center">
        <h3 className="text-xs">{year} © 59S, All Rights Reserved</h3>
      </div>
    </div>
  )
}

export default SWelcome
